export const useMobileMenuOpen = () => useState("useMobileMenuOpen", () => false);
